module.exports = __webpack_public_path__ + "img/alturamaxima.464dc171.png";